import { APP_LOAD, SITE_SUBMITTED, SITE_UPDATED, LOGIN, LOGOUT } from '../constants/actionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case LOGIN:
    case APP_LOAD:
      return action.payload && action.payload.sites ? action.payload.sites : state;
    case SITE_SUBMITTED:
      return [...state, action.payload];
    case SITE_UPDATED:
      if(action.payload.id) {
        return state.map(site =>
          site.id === action.payload.id ? { ...action.payload } : site
        )
      }else {
        alert('Update failed');
        return state;
      }
    case LOGOUT:
      return [];
    default:
      return state;
  }
};
